import React from 'react'
import { ReactComponent as Kasse } from 'media/icons/kasse.svg'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const StyledSideListWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`
const StyledSideListHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	margin-bottom: 10px;
`
const StyledOpenCashRegisterModal = styled.div`
	display: flex;
	padding-right: 20px;
	align-items: center;
	background: #F4F4F4;
	box-shadow: 0px 1px 2px rgba(90, 90, 90, 0.196784);
	border-radius: 3px;
	cursor: pointer;
	& svg {
		margin-right: 5px;
	}
`

const SideListHeader = ({ toggleCashRegisterModal }) => {
	const [t] = useTranslation()
	return (
		<StyledSideListWrapper>
			<StyledSideListHeader>
				<p style={{ margin: '10px 108px 10px 0px', fontSize: '16px' }}>{t('options_section.strings.order_types')}</p>
				<StyledOpenCashRegisterModal onClick={() => toggleCashRegisterModal(true)}>
					<Kasse />
					<span>{t('common.fields.cash_register')}</span>
				</StyledOpenCashRegisterModal>
			</StyledSideListHeader>
		</StyledSideListWrapper>
	)
}

export default SideListHeader
